export interface TurnCurvePoint {
  turn_position: number;
  avg_cost_usd: number;
  avg_cumulative_cost_usd: number;
  conversation_count: number;
  avg_input_tokens: number;
  avg_output_tokens: number;
  avg_cached_read_tokens: number;
  avg_cache_write_tokens: number;
  avg_thought_tokens: number;
}

export interface TurnCurveSummary {
  total_conversations: number;
  total_turns: number;
  avg_cost_per_turn_usd: number;
  avg_total_conversation_cost_usd: number;
  percentile_threshold: number | null;
  min_samples_threshold: number;
  total_input_tokens: number;
  total_output_tokens: number;
  total_cached_read_tokens: number;
  total_cache_write_tokens: number;
  total_thought_tokens: number;
}

export interface TurnCurveResponse {
  summary: TurnCurveSummary;
  turn_curve: TurnCurvePoint[];
}

export type SampleMode =
  | 'all'
  | 'p10'
  | 'p50'
  | 'p90'
  | 'p99'
  | 'p99.9'
  | 'p100';
export type DaysWindow = 1 | 7 | 30 | 'all';

export type AgentTier = 'max' | 'regular' | 'quick';
export const AGENT_TIERS: readonly AgentTier[] = ['max', 'regular', 'quick'];

export interface AgentInfo {
  name: string;
  tier: AgentTier;
}
